import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const GenderSalaryByExperience: React.FC = () => {
  const { locale } = useRouter();

  const dataEN = [
    { exp: '<2y', Men: 24.254045307443363, Women: 25.346863468634684 },
    { exp: '2-5y', Men: 37.86383442265795, Women: 33.21071428571428 },
    { exp: '5-10y', Men: 47.737415477084895, Women: 41.12234042553192 },
    { exp: '>10y', Men: 53.20698510529019, Women: 48.737430167597765 },
    {
      exp: 'Not specified',
      Men: 23.15841584158416,
      Women: 24.48770491803279
    }
  ];

  const dataES = [
    { exp: '<2y', Hombres: 24.254045307443363, Mujeres: 25.346863468634684 },
    { exp: '2-5y', Hombres: 37.86383442265795, Mujeres: 33.21071428571428 },
    { exp: '5-10y', Hombres: 47.737415477084895, Mujeres: 41.12234042553192 },
    { exp: '>10y', Hombres: 53.20698510529019, Mujeres: 48.737430167597765 },
    {
      exp: 'No especificado',
      Hombres: 23.15841584158416,
      Mujeres: 24.48770491803279
    }
  ];

  const data = locale === 'es' ? dataES : dataEN;
  const womenKey = locale === 'es' ? 'Mujeres' : 'Women';
  const menKey = locale === 'es' ? 'Hombres' : 'Men';

  return (
    <div>
      <StyledRecharts className="gender">
        <ResponsiveContainer height={450}>
          <BarChart data={data}>
            <XAxis
              type="category"
              dataKey="exp"
              tickLine={false}
              axisLine={false}
            />
            <YAxis
              tickLine={false}
              width={60}
              axisLine={false}
              tickMargin={5}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              padding={{ bottom: 20 }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=": "
              formatter={(value: number) => `€${value.toFixed(1)}K`}
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: -5 }}
            />
            <Bar
              dataKey={womenKey}
              barSize={12}
              radius={5}
              fill="#746FB3"
            ></Bar>
            <Bar dataKey={menKey} barSize={12} radius={5} fill="#1B9D76" />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default GenderSalaryByExperience;
